import {
  FETCH_LLM_OPTIONS_FAILURE,
  FETCH_LLM_OPTIONS_REQUEST,
  FETCH_LLM_OPTIONS_SUCCESS,
} from "../constants/actionTypes";

const getStoredOptions = () => {
  try {
    const stored = localStorage.getItem("llm_options");
    if (stored) {
      const parsed = JSON.parse(stored);
      if (Array.isArray(parsed) && parsed.length > 0) return parsed;
    }
  } catch (_) {}
  return [];
};

const getStoredGroupCustomers = () => {
  try {
    const stored = localStorage.getItem("group_customers");
    if (stored) {
      const parsed = JSON.parse(stored);
      if (Array.isArray(parsed)) return parsed;
    }
  } catch (_) {}
  return [];
};

const initialState = {
  loading: false,
  data: getStoredOptions(),
  groupCustomers: getStoredGroupCustomers(),
  error: null,
};

const llmOptionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LLM_OPTIONS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_LLM_OPTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.options,
        groupCustomers: action.payload.groupCustomers,
      };
    case FETCH_LLM_OPTIONS_FAILURE:
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
};

export default llmOptionsReducer;
